import React, { Component } from 'react'
import classnames from 'classnames'

class HeroImage extends Component {
  constructor(props) {
    super(props)
    this.state = { complete: false }
  }
  componentDidMount() {
    this.props.onPrepare && this.props.onPrepare(this.props.name)
  }

  componentWillUnmount() {
    if (this.img) {
      this.img.onload = null
      this.img = null
    }
  }
  
  onLoad = () => {
    this.setState({
      complete: true
    }, () => {
      this.props.onLoad && this.props.onLoad(this.props.name)
    })
  }

  render() {
    const { width, height, src, mediaClassNames  } = this.props 
    const { complete } = this.state
    const imageClassNames = classnames({
      'media-image--complete': complete,
      'media-image--vertical': height / width > 1,
    }, 'media-image')
    const style = {
    //   backgroundImage: `url(${src})`
    }
    return (
      <div style={style} className={`${imageClassNames} ${mediaClassNames}`} >
        <img src={ src } onLoad={this.onLoad} alt={this.props.name}/>
      </div>
    )
  }
}

export default HeroImage



// WEBPACK FOOTER //
// ./src/components/hero/hero-image.js